import axios from 'axios'

const MTS_ADDRESS = "https://be-mts.ems-a.com"


export function sensorConsulte(unique_code){
    const url = `${MTS_ADDRESS}/v1/equipments/find?ui=${unique_code}` 
    return axios({
        method: 'GET',
        url: url,
    })
}
